// src/admin/AdminRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function AdminRoute({ children }) {
  const loc = useLocation();
  let user = null;

  try {
    user = JSON.parse(localStorage.getItem("bb_user"));
  } catch {}

  // not logged in -> go login, and remember where to come back
  if (!user?.token) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }

  // logged in but not admin -> kick to home
  if (user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
}
